var WebFont = require("webfontloader");

export default {
  init: function () {
    WebFont.load({
      typekit: {
        id: "ndi2qxg",
      },
      // custom: {
      //   families: ['WildLove Script', 'Domaine Text Test'],
      // },
    });
  },
};
